/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";

const NavCardsSectionItem = (props) => {

    const item = props?.item;
    // const guid = item?.guid;
    const nav_title = item?.nav_title;
    const description = item?.description;
    const banner_image = item?.banner_image;
    const path = item?.path;

    const img_url = banner_image?.image?.url;
    // TODO: Use image settings
    // const image_settings = banner_image?.settings;
    // const img_guid = banner_image?.guid;

    const navigate = useNavigate();

    const handleClick = async () => {
        if (path) {
            navigate(path);
        }
    };

    return (
        <Fragment>
            <div className='simplicity-section-list-item'>
                <div className="simplicity-section-list-item-container">
                    <div
                        className="simplicity-nav-cards-image"
                        style={{
                            backgroundImage: `url(${img_url})`,
                        }}
                    ></div>

                    <div className="simplicity-nav-cards-content">
                        <div className="simplicity-nav-cards-title">
                            {nav_title}
                        </div>
                        <div className="simplicity-nav-cards-description">
                            {description}
                        </div>
                        <div className='simplicity-nav-cards-action'>
                            <button
                                className="simplicity-nav-cards-button"
                                onClick={handleClick}
                            >Learn More</button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { NavCardsSectionItem };
